export const escapeFileName = (fileName) => encodeURIComponent(fileName.replace(/%/g, ''));
